import { render, staticRenderFns } from "./IconSmartPhone.vue?vue&type=template&id=44567d14&"
import script from "./IconSmartPhone.vue?vue&type=script&lang=js&"
export * from "./IconSmartPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports